import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Title,
} from './styles';

const GroupWrapper = ({
  title, children,
}) => (
  <Container>
    {title && <Title>{title}</Title>}
    {children}
  </Container>
);

GroupWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

GroupWrapper.defaultProps = {
  title: null,
};

export default GroupWrapper;
